import csTools from 'cornerstone-tools';
const BaseAnnotationTool = csTools.importInternal('base/BaseAnnotationTool');
const external = csTools.external;
// import external from './../../externalModules.js';
// import BaseAnnotationTool from '../base/BaseAnnotationTool.js';

const EVENTS = csTools.EVENTS
// import EVENTS from './../../events.js';
const toolStyle = csTools.toolStyle;
// import toolStyle from './../../stateManagement/toolStyle.js';
const textStyle = csTools.textStyle;
// import textStyle from './../../stateManagement/textStyle.js';
const toolColors = csTools.toolColors;
// import toolColors from './../../stateManagement/toolColors.js';
const moveNewHandle = csTools.importInternal('manipulators/moveNewHandle');
// import { moveNewHandle } from './../../manipulators/index.js';
const getPixelSpacing = csTools.importInternal('util/getPixelSpacing');
// import getPixelSpacing from './../../util/getPixelSpacing.js';
const lineSegDistance = csTools.importInternal('util/lineSegDistance');
// import lineSegDistance from './../../util/lineSegDistance.js';
const throttle = csTools.importInternal('util/throttle');
// import throttle from './../../util/throttle.js';

const addToolState = csTools.addToolState;
const removeToolState = csTools.removeToolState;
const getToolState = csTools.getToolState;
// import {
//   addToolState,
//   removeToolState,
//   getToolState,
// } from './../../stateManagement/toolState.js';
const getNewContext = csTools.importInternal('drawing/getNewContext');
const draw = csTools.importInternal('drawing/draw');
const drawLine = csTools.importInternal('drawing/drawLine');
const setShadow = csTools.importInternal('drawing/setShadow');
// import { getNewContext, draw, setShadow } from './../../drawing/index.js';
const drawLinkedTextBox = csTools.importInternal('drawing/drawLinkedTextBox');
// import drawArrow from './../../drawing/drawArrow.js';
const drawHandles = csTools.importInternal('drawing/drawHandles');
// import drawHandles from './../../drawing/drawHandles.js';

const textBoxWidth = csTools.importInternal('drawing/drawTextBox');
// import { textBoxWidth } from './../../drawing/drawTextBox.js';
const cursors = cornerstoneTools.import('tools/cursors');
// import { arrowAnnotateCursor } from '../cursors/index.js';

/**
 * @public
 * @class LineDrawTool
 * @memberof Tools.Annotation
 * @classdesc Tool for drawing lines.
 * @extends Tools.Base.BaseAnnotationTool
 */
export default class LineDrawTool extends BaseAnnotationTool {
    constructor(props = {}) {
        const defaultProps = {
            name: 'LineDraw',
            supportedInteractionTypes: ['Mouse', 'Touch'],
            svgCursor: cursors.lengthCursor,
            configuration: {
                drawHandles: true,
                drawHandlesOnHover: true,
                hideHandlesIfMoving: false,
                renderDashed: false,
            },
        };

        super(props, defaultProps);

        this.throttledUpdateCachedStats = throttle(this.updateCachedStats, 110);
    }

    createNewMeasurement(data) {
        let eventData = data.detail
        const goodEventData =
            eventData && eventData.currentPoints && eventData.currentPoints.image;

        console.log(eventData);
        if (!goodEventData) {
            console.error(
                `required eventData not supplied to tool ${this.name}'s createNewMeasurement`
            );

            return;
        }

        const { x, y } = eventData.currentPoints.image;

        return {
            visible: true,
            active: true,
            color: undefined,
            invalidated: true,
            handles: {
                start: {
                    x,
                    y,
                    highlight: true,
                    active: false,
                },
                end: {
                    x,
                    y,
                    highlight: true,
                    active: true,
                },
            },
        };
    }

    /**
     *
     *
     * @param {*} element
     * @param {*} data
     * @param {*} coords
     * @returns {Boolean}
     */
    pointNearTool(element, data, coords) {
        const hasStartAndEndHandles =
            data && data.handles && data.handles.start && data.handles.end;
        const validParameters = hasStartAndEndHandles;

        if (!validParameters) {
            console.warn(
                `invalid parameters supplied to tool ${this.name}'s pointNearTool`
            );

            return false;
        }

        if (data.visible === false) {
            return false;
        }

        return (
            lineSegDistance(element, data.handles.start, data.handles.end, coords) <
            25
        );
    }

    updateCachedStats(image, element, data) {
        const { rowPixelSpacing, colPixelSpacing } = getPixelSpacing(image);

        // Set rowPixelSpacing and columnPixelSpacing to 1 if they are undefined (or zero)
        const dx =
            (data.handles.end.x - data.handles.start.x) * (colPixelSpacing || 1);
        const dy =
            (data.handles.end.y - data.handles.start.y) * (rowPixelSpacing || 1);

        // Calculate the length, and create the text variable with the millimeters or pixels suffix
        const length = Math.sqrt(dx * dx + dy * dy);

        // Store the length inside the tool for outside access
        data.length = length;
        data.invalidated = false;
    }

    renderToolData(evt) {
        const eventData = evt.detail;
        const {
            handleRadius,
            drawHandlesOnHover,
            hideHandlesIfMoving,
            renderDashed,
        } = this.configuration;
        const toolData = getToolState(evt.currentTarget, this.name);

        if (!toolData) {
            return;
        }

        // We have tool data for this element - iterate over each one and draw it
        const context = getNewContext(eventData.canvasContext.canvas);
        const { image, element } = eventData;
        const { rowPixelSpacing, colPixelSpacing } = getPixelSpacing(image);

        const lineWidth = toolStyle.getToolWidth();
        const lineDash = cornerstoneTools.getModule('globalConfiguration').configuration.lineDash;

        for (let i = 0; i < toolData.data.length; i++) {
            const data = toolData.data[i];

            if (data.visible === false) {
                continue;
            }

            draw(context, context => {
                // Configurable shadow
                setShadow(context, this.configuration);

                const color = toolColors.getColorIfActive(data);

                const lineOptions = { color };

                if (renderDashed) {
                    lineOptions.lineDash = lineDash;
                }

                // Draw the measurement line
                drawLine(
                    context,
                    element,
                    data.handles.start,
                    data.handles.end,
                    lineOptions
                );

                // Draw the handles
                const handleOptions = {
                    color,
                    handleRadius,
                    drawHandlesIfActive: drawHandlesOnHover,
                    hideHandlesIfMoving: true,
                };

                if (this.configuration.drawHandles) {
                    drawHandles(context, eventData, data.handles, handleOptions);
                }

                // if (!data.handles.textBox.hasMoved) {
                //     const coords = {
                //         x: Math.max(data.handles.start.x, data.handles.end.x),
                //     };

                //     // Depending on which handle has the largest x-value,
                //     // Set the y-value for the text box
                //     if (coords.x === data.handles.start.x) {
                //         coords.y = data.handles.start.y;
                //     } else {
                //         coords.y = data.handles.end.y;
                //     }

                //     data.handles.textBox.x = coords.x;
                //     data.handles.textBox.y = coords.y;
                // }

                // // Move the textbox slightly to the right and upwards
                // // So that it sits beside the length tool handle
                // const xOffset = 10;

                // // Update textbox stats
                // if (data.invalidated === true) {
                //     if (data.length) {
                //         this.throttledUpdateCachedStats(image, element, data);
                //     } else {
                //         this.updateCachedStats(image, element, data);
                //     }
                // }

                // const text = textBoxText(data, rowPixelSpacing, colPixelSpacing);

                // drawLinkedTextBox(
                //     context,
                //     element,
                //     data.handles.textBox,
                //     text,
                //     data.handles,
                //     textBoxAnchorPoints,
                //     color,
                //     lineWidth,
                //     xOffset,
                //     true
                // );
            });
        }

        // - SideEffect: Updates annotation 'suffix'
        function textBoxText(annotation, rowPixelSpacing, colPixelSpacing) {
            const measuredValue = _sanitizeMeasuredValue(annotation.length);

            // measured value is not defined, return empty string
            if (!measuredValue) {
                return '';
            }

            // Set the length text suffix depending on whether or not pixelSpacing is available
            let suffix = 'mm';

            if (!rowPixelSpacing || !colPixelSpacing) {
                suffix = 'pixels';
            }

            annotation.unit = suffix;

            return `${measuredValue.toFixed(2)} ${suffix}`;
        }

        function textBoxAnchorPoints(handles) {
            const midpoint = {
                x: (handles.start.x + handles.end.x) / 2,
                y: (handles.start.y + handles.end.y) / 2,
            };

            return [handles.start, midpoint, handles.end];
        }
    }

    addNewMeasurement(evt, interactionType) {
        const element = evt.detail.element;
        const measurementData = this.createNewMeasurement(evt);

        // Associate this data with this imageId so we can render it and manipulate it
        addToolState(element, this.name, measurementData);
        external.cornerstone.updateImage(element);

        moveNewHandle(
            evt.detail,
            this.name,
            measurementData,
            measurementData.handles.end,
            this.options,
            interactionType,
            success => external.cornerstone.updateImage(element)
        );
    }
}

/**
 * Attempts to sanitize a value by casting as a number; if unable to cast,
 * we return `undefined`
 *
 * @param {*} value
 * @returns a number or undefined
 */
function _sanitizeMeasuredValue(value) {
    const parsedValue = Number(value);
    const isNumber = !isNaN(parsedValue);

    return isNumber ? parsedValue : undefined;
}